import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { environment } from '@environment';
import { firstValueFrom } from 'rxjs';
import { APP_STORAGE, AppStorage } from '~/app.storage';
import { Credentials } from '~/domain/types/credentials';
import { Session } from '~/domain/types/session';

@Service()
export class AuthService {
  private readonly _http = inject(HttpClient);
  private readonly _storage = inject(APP_STORAGE);

  async login(credentials: Credentials): Promise<void> {
    const headers = { 'x-realm': 'backoffice' };

    const { accessToken } = await firstValueFrom(
      this._http.post<Session>(`${environment.api}/auth/login`, credentials, { headers }),
    );

    this._storage.setItem(AppStorage.AccessToken, accessToken);
  }
}
